import React, { useEffect, useState } from "react";
import {
  collection,
  query,
  where,
  orderBy,
  limit,
  onSnapshot,
  documentId,
} from "firebase/firestore";
import { db } from "../../firebase";
import NotesContainerGlobalMobile from "../Notes/NotesContainerGlobalMobile";
import { CircularProgress } from "@mui/material";
import { useAuth } from "../../contexts/AuthContext";
import { roles } from "../../firebase.collection";

function TherapyNoteContainerAllMobile(props) {
  const [notes, setNotes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [, setUserRole] = useState("");
  const { currentUser } = useAuth();

  const queryRole = () => {
    if (currentUser) {
      const userId = currentUser.uid;
      const q = query(roles, where(documentId(), "==", userId));

      const unsubscribe = onSnapshot(q, (querySnapshot) => {
        if (!querySnapshot.empty) {
          const role = querySnapshot.docs[0].data().role;
          setUserRole(role);
          fetchNotes(role); // Appelle fetchNotes après avoir récupéré le rôle
        } else {
          console.log("❌ Aucun rôle trouvé pour cet utilisateur.");
          setUserRole(null);
        }
      });

      return () => unsubscribe();
    }
  };

  const fetchNotes = (role) => {
    if (!currentUser) return;

    const notesRef = collection(db, "notes");
    let q;

    if (role === "Super Admin" || role === "Clinical Director") {
      // 🔹 Super Admin et Clinical Director voient toutes les therapyNotes
      q = query(
        notesRef,
        where("noteType", "==", "therapyNote"),
        orderBy("effectiveDateTime", "desc"),
        limit(50)
      );
    } else if (role === "Therapist") {
      // 🔹 Les therapists ne voient que leurs propres therapyNotes
      q = query(
        notesRef,
        where("noteType", "==", "therapyNote"),
        //where("doneBy", "==", currentUser.displayName), // 🔴 Filtre par le thérapeute connecté
        orderBy("effectiveDateTime", "desc"),
        limit(50)
      );
    } else {
      console.log("⚠️ Rôle non autorisé pour voir les therapyNotes");
      setNotes([]); // 🔴 Vide la liste des notes si le rôle ne permet pas l'accès
      return;
    }

    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const notesData = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setLoading(false);
      setNotes(notesData);
    });

    return () => unsubscribe();
  };

  useEffect(() => {
    if (notes.length > 0) {
    } else {
      console.log("❌ Aucune note affichée.");
    }
  }, [notes]);

  useEffect(() => {
    if (currentUser) {
      return queryRole();
    }
    return undefined;
    // queryRole intentionally captures the current user subscription and note query.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser]);

  return (
    <div className="notes-container-global">
      {loading ? (
        <div style={{ textAlign: "center" }}>
          <CircularProgress />
          <p>Loading, please wait...</p>
        </div>
      ) : (
        notes.map((note) => {
          const dateOptions = {
            day: "numeric",
            month: "short",
            year: "numeric",
          };

          const dateOptions2 = {
            day: "numeric",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
          };

          const timeOptions = {
            hour: "2-digit",
            minute: "2-digit",
          };

          const formattedTimestamp = note.createdAt
            ? new Intl.DateTimeFormat("en-EN", dateOptions2).format(
                note.createdAt.toDate()
              )
            : "";

          const formattedDate = note.effectiveDateTime
            ? new Intl.DateTimeFormat("en-EN", dateOptions).format(
                note.effectiveDateTime.toDate()
              )
            : "";

          const formattedLastModification = note.updateAt
            ? new Intl.DateTimeFormat("en-EN", dateOptions2).format(
                note.updateAt.toDate()
              )
            : "";

          const formattedTime = note.effectiveDateTime
            ? new Intl.DateTimeFormat("en-EN", timeOptions).format(
                note.effectiveDateTime.toDate()
              )
            : "";

          return (
            <NotesContainerGlobalMobile
              key={note.id}
              noteContent={note.noteContent}
              effectiveDate={note.effectiveDateTime}
              noteDate={formattedDate}
              noteTime={formattedTime}
              doneBy={note.doneBy}
              timeStamp={formattedTimestamp}
              lastModification={formattedLastModification}
              clientPic={note.clientProfilePicture}
              clientFirstName={note.clientFirstName}
              clientLastName={note.clientLastName}
              noteId={note.id}
              {...note}
            />
          );
        })
      )}
    </div>
  );
}

export default TherapyNoteContainerAllMobile;
